import React, { useReducer, createContext } from "react";
import { authenticationReducer, authInitialState } from "../reducers";
import constant from "../constants/authenticationConstant";
import { authenticationService } from "../services";
import { toast } from "react-toastify"

export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = (props) => {

    const [state, dispatch] = useReducer(authenticationReducer, authInitialState);

    const login = (data, onSuccess) => {

        dispatch(request());

        authenticationService.login(data).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                localStorage.setItem(process.env.REACT_APP_LS_USER,
                    JSON.stringify(response.data.user));

                localStorage.setItem(process.env.REACT_APP_LS_TOKEN, response.data.token);

                dispatch(success(response.data.user));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("login failed!");

                dispatch(fail());
            });

        function success(user) { return { type: constant.LOGIN_SUCCESS, payload: user }; }
        function fail() { return { type: constant.LOGIN_FAIL }; }
        function request() { return { type: constant.LOGIN_REQUEST }; }
    };

    const logout = () => {

        localStorage.clear(process.env.REACT_APP_LS_USER);

        dispatch({ type: constant.LOG_OUT });
    }

    return (
        <AuthenticationContext.Provider value={[state, { login, logout }]}>{props.children}
        </AuthenticationContext.Provider>
    );
};

